export interface UsageData {
  input_tokens?: number;
  output_tokens?: number;
  input_audio_tokens?: number;
  output_audio_tokens?: number;
  reasoning_tokens?: number;
  cache_creation_input_tokens?: number;
  cache_read_input_tokens?: number;
  total_tokens?: number;

  input_charges?: number;
  output_charges?: number;
  input_audio_charges?: number;
  output_audio_charges?: number;
  reasoning_charges?: number;
  cache_creation_input_charges?: number;
  cache_read_input_charges?: number;
  total_charges?: number;
}

export interface SessionUsageData {
  sessionStart: number;
  [key: string]: UsageData | number;
}

export const FREE_MODELS = new Set(['gpt-mini', 'gemini-flash', 'claude-haiku']);

export const prepareChartData = (sessionUsage: SessionUsageData, dataKey: string): Record<string, number> => {
  return Object.entries(sessionUsage).reduce((acc: Record<string, number>, [model, data]) => {
    if (
      (model !== 'sessionStart' && data && typeof data === 'object') &&
      !(FREE_MODELS.has(model.toLowerCase()) && dataKey.includes('Charge'))
    ) {
      acc[model] = (data as UsageData)[dataKey as keyof UsageData] || 0;
    }
    return acc;
  }, {});
};

export const combineChartData = (dataObjects: Record<string, number>[]): Record<string, number> => {
  const combined: Record<string, number> = {};

  dataObjects.forEach(obj => {
    Object.entries(obj).forEach(([model, value]) => {
      if (!combined[model]) {
        combined[model] = 0;
      }
      combined[model] += value;
    });
  });

  return combined;
};

export const formatSessionStartTime = (timestamp: number): string => {
  return new Date(timestamp).toLocaleString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
};
